import styled from 'styled-components'
import { Color } from '../../theme/color'

const BannerContainer = styled.div`
  overflow: hidden;
  width: 100%;
  border-bottom-right-radius: 32px;
  border-bottom-left-radius: 32px;
  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const DetailBannerContainer = styled(BannerContainer)<{ $slideLength: number }>`
  aspect-ratio: 1/0.9;
  .swiper,
  .swiper-slide {
    position: relative;
    height: 100%;
    cursor: auto;
  }
  .swiper-pagination {
    ${({ $slideLength }) =>
      $slideLength > 1
        ? `
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          bottom: 8px;
          left: 50%;
          z-index: 1;
          transform: translateX(-50%);
          .swiper-pagination-bullet {
            width: 6px;
            height: 6px;
            margin: 0 2px;
            border: 1px solid ${Color.gray_2};
            border-radius: 100%;
            background-color: ${Color.white};
            &.swiper-pagination-bullet-active {
              width: 8px;
              height: 8px;
              margin: 0 1.5px;
              border: none;
              background-color: ${Color.black};
            }
          }
        `
        : `display:none;`}
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
